import type { GetIndicatorsByParentIdResponse } from '@risksmart-app/trpc/src/types';
import type { GetIndicatorsByParentIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetIndicatorsByParentIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetIndicatorsByParentIdArgs = {
  parentId: string;
};

export const useLazyGetIndicatorsByParentId = createLazyQueryHook<
  UseLazyGetIndicatorsByParentIdArgs,
  GetIndicatorsByParentIdResponse,
  GetIndicatorsByParentIdQuery
>({
  trpcQuery: (client, { parentId }) =>
    client.frontend.indicator.indicatorsByParentId.query({ parentId }),
  mapTrpcDataToGraphQL: (data) => data,
  graphqlDocument: GetIndicatorsByParentIdDocument,
  graphqlVariables: ({ parentId }) => ({ parentId }),
});
